// 加法 精度换算
import i2Multiply from "./i2Multiply"
const i2Add = function (n1, n2) {
  const num1 = Number(n1) || 0
  const num2 = Number(n2) || 0
  let r1, r2, m
  try {
    r1 = num1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = num2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(1000, Math.max(r1, r2))
  // return (num1 * m + num2 * m) / m
  return (i2Multiply(num1, m) + i2Multiply(num2, m)) / m
}

export default i2Add
